import { createSelector } from 'reselect';
import _ from 'lodash';
import {
  getSessions,
  getActiveSession,
} from 'PointOfSale/modules/individualServing/state/selectors';
import {
  getCurrentSelectedMenu,
  getFoodItems,
} from 'PointOfSale/modules/mealTypes/state/selector';

// selector

export const getCurrentSession = state =>
  _.get(state, 'PointOfSaleState.servingOptions.currentSession');

export const getSelectedFoodItems = createSelector(
  [getFoodItems, getCurrentSelectedMenu],
  (foodItems, selectedMenuItem) => {
    const allFoodItemsClone = _.cloneDeep(foodItems);
    const selectedMenuFoodItems = allFoodItemsClone[selectedMenuItem];

    if (!selectedMenuFoodItems) return [];

    let allFoodItemsArray = [];

    const keys = Object.keys(selectedMenuFoodItems);

    allFoodItemsArray = _.reduce(
      keys,
      function(flattened, other) {
        return flattened.concat(selectedMenuFoodItems[other]);
      },
      []
    );

    const filteredItems = _.filter(allFoodItemsArray, 'selected');

    return filteredItems;
  }
);

export const getQuickServeItems = state =>
  createSelector(
    [getFoodItems],
    foodItems => {}
  );

export const cepTypes = state =>
  _.get(state, 'PointOfSaleState.servingOptions.cepTypes');

export const getCurrentSessionAutoServe = state =>
  _.get(
    state,
    'PointOfSaleState.servingOptions.currentSession.autoServe',
    false
  );

export const getSubMenuItems = state =>
  _.get(state, 'PointOfSaleState.servingOptions.servingSubMenuItems');

export const getStartingCash = state =>
  _.get(state, 'PointOfSaleState.servingOptions.startingCash', '0.00');

// reselect function
export const getQuickServeItemsDropdown = createSelector(
  [getSelectedFoodItems, getCurrentSessionAutoServe],
  (filteredItems, autoServe) => {
    const quickServeItems = [];

    filteredItems &&
      _.each(filteredItems, item => {
        const mealType = {};
        mealType.text = item.Description;
        mealType.key = item.ItemId;
        mealType.value = item.Description;
        quickServeItems.push(mealType);
      });

    const sortedItems = _(quickServeItems)
      .sortBy(qsi => qsi.text)
      .uniqBy('key')
      .value();

    if (!autoServe) {
      sortedItems.unshift({
        text: 'None',
        value: 'None',
        key: filteredItems.length + 1,
      });
    }

    return sortedItems;
  }
);

export const getCepTypes = createSelector(
  [cepTypes],
  cepTypes => {
    const types = [];
    _.each(cepTypes, type => {
      const cepType = {};
      cepType.key = type.Id;
      cepType.value = type.Id;
      cepType.text = type.Description;
      types.push(cepType);
    });
    return types;
  }
);

/** Retrieves autoServe based on current active session */
export const getAutoServe = state => {
  const activeSession = getActiveSession(state);
  const sessions = getSessions(state);
  return _.get(sessions, [activeSession, 'autoServe'], false);
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/state/selector.js